import { EnumeratedMediaDevices } from 'features/user-media/types';
import webrtcAdapter from 'webrtc-adapter';
import { getDefaultMediaDevice } from 'features/user-media/utils';
import { resolvePersistedDevice } from 'features/user-media/utils/resolvePersistedDevice';

// Gets a correct device to be used on the first user media request
export const getDefaultPromptedDevice = (
  mediaDevices: EnumeratedMediaDevices,
  kind: MediaDeviceKind
) => {
  const persistedDevice = resolvePersistedDevice(mediaDevices, kind);
  if (persistedDevice) {
    return persistedDevice;
  }

  // Firefox returns `deviceId` even for devices without permissions.
  // We will use this device for our request.
  if (webrtcAdapter.browserDetails.browser === 'firefox') {
    return mediaDevices[kind][0]?.deviceId;
  }

  return getDefaultMediaDevice(mediaDevices, kind);
};
